module.exports = __webpack_public_path__ + "img/gbwhatsappDndMode.f6eb8aa5.webp";